// pages/PaymentSuccessPage.js
import React from 'react';
import { Header, Footer } from '../components/HomePage';
import PaymentSuccessContent from '../components/ReservationForms/Payment/PaymentSuccessContent';

function PaymentSuccessPage() {
  return (
    <>
      <Header />
      <PaymentSuccessContent />
      <Footer />
    </>
  );
}

export default PaymentSuccessPage;